import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=2ddf13b4&scoped=true"
import script from "./admin.vue?vue&type=script&lang=ts"
export * from "./admin.vue?vue&type=script&lang=ts"
import style0 from "./admin.vue?vue&type=style&index=0&id=2ddf13b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf13b4",
  null
  
)

export default component.exports